'use client';
import { useState, useEffect } from 'react';
import API_BASE_URL from '../config/api.js';
import '../css/HeroSection.css';

const HeroSection = ({ onSuccess }) => {
  const [username, setUsername] = useState('');
  const [showNameForm, setShowNameForm] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);
  const [typedGreeting, setTypedGreeting] = useState('');
  const [spinnerVisible, setSpinnerVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowNameForm(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  const typeText = (text, callback) => {
    setTypedGreeting('');
    let index = 0;

    function typeChar() {
      if (index < text.length) {
        const char = text.charAt(index);
        setTypedGreeting((prev) => prev + char);
        index += 1;
        setTimeout(typeChar, 70);
      } else if (callback) {
        callback();
      }
    }

    typeChar();
  };

  const handleSubmit = async () => {
    setErrorMessage('');
    if (!username.trim()) {
      shakeInput();
      return;
    }

    if (!/^[A-Za-z\s]+$/.test(username)) {
      setErrorMessage('Please enter only letters. No numbers or symbols allowed.');
      shakeInput();
      return;
    }

    try {
      const res = await fetch(`${API_BASE_URL}/api/guests`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name: username }),
      });

      const data = await res.json();

      if (!res.ok) {
        setErrorMessage(data?.errors?.[0]?.msg || 'Invalid name.');
        shakeInput();
        return;
      }

      const trimmedName = username.trim();
      setShowNameForm(false);
      setShowWelcome(true);

      typeText(`Hi ${trimmedName} 👋`, () => {
        setTimeout(() => {
          setSpinnerVisible(true);
          setTimeout(() => {
            onSuccess(trimmedName);
          }, 600);
        }, 3200);
      });
    } catch (error) {
      console.error('Error submitting name:', error);
      setErrorMessage('Failed to connect to server. Please try again later.');
    }
  };

  const shakeInput = () => {
    const input = document.getElementById('username1');
    if (input) {
      input.style.animation = 'shake 0.5s';
      setTimeout(() => {
        input.style.animation = '';
      }, 500);
    }
  };

  return (
    <div className={`intro-overlay ${spinnerVisible ? 'hidden' : ''}`}>
      <div className={`content-wrapper ${showWelcome ? 'content-wrapper--welcome' : ''}`}>
        {!showWelcome && (
          <div className="greeting">
            Hi<span className="dots"></span>
          </div>
        )}

        {showNameForm && !showWelcome && (
          <div className={`name-form ${showNameForm ? 'active' : ''}`}>
            <label className="form-label" htmlFor="username1">
              What should I call you?
            </label>
            <input
              type="text"
              id="username1"
              className="name-input"
              placeholder="Type your name"
              autoComplete="off"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
            />
            <button type="button" className="submit-button" onClick={handleSubmit}>
              Continue
            </button>
            {errorMessage && <p className="error-message">{errorMessage}</p>}
          </div>
        )}

        {showWelcome && (
          <div className="welcome-screen active">
            <div className="greeting greeting--welcome">
              {typedGreeting.split('').map((char, idx) =>
                char === '👋' ? (
                  <span key={idx} className="emoji">{char}</span>
                ) : (
                  <span key={idx}>{char}</span>
                )
              )}
            </div>

            <div className="welcome-details">
              <p className="intro-subtitle">Welcome to MyPortfolio</p>
              <h1 className="intro-name">Shivashanker Kanugula</h1>
              <div className="role-wrapper">
                <p className="intro-subtitle intro-role">
                  I&apos;m a <span className="role">Full-Stack Developer</span>
                </p>
              </div>

              <p className="intro-redirect">Redirecting to portfolio...</p>
            </div>
          </div>
        )}

        {spinnerVisible && (
          <div className="spinner" />
        )}
      </div>
    </div>
  );
};

export default HeroSection;
